import type { Screen } from "./Screen";

export abstract class BaseScreen implements Screen {

    protected root!: HTMLElement;

    public getRoot(): HTMLElement {

        return this.root;

    }

    public mount(): void {
    }

    public update(): void {
    }

    public unmount(): void {
    }

}